import { render, staticRenderFns } from "./PictureAndVideoCreate.vue?vue&type=template&id=823c2e06&scoped=true&"
import script from "./PictureAndVideoCreate.vue?vue&type=script&lang=js&"
export * from "./PictureAndVideoCreate.vue?vue&type=script&lang=js&"
import style0 from "./PictureAndVideoCreate.vue?vue&type=style&index=0&id=823c2e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823c2e06",
  null
  
)

export default component.exports